import type { UserDetailsResponse, UserDetailsResponseRolesItem } from "@/utils/api/user-service/models"

/**
 * Maps role names to user-friendly display names
 */
const ROLE_DISPLAY_NAMES: Record<UserDetailsResponseRolesItem, string> = {
  ROLE_USER: 'User',
  ROLE_ADMIN: 'Administrator',
  ROLE_ORGANIZATION_ADMIN: 'Organization Admin',
  ROLE_SPORTS_ADMIN: 'Sports Admin',
  ROLE_STUDENT: 'Student',
  ROLE_ACADEMIC_REG: 'Academic Registry',
  ROLE_SENATE_ADMIN: 'Senate Admin',
  ROLE_ALUMNI: 'Alumni',
}

/**
 * Gets a user-friendly display name for a user role
 * @param roleName The role name from the API
 * @param fallback Optional fallback string if the role is unknown
 * @returns A formatted, user-friendly role name
 */
export function formatRoleName(roleName: UserDetailsResponseRolesItem | undefined, fallback: string = 'Unknown'): string {
  if (!roleName)
    return fallback
  return ROLE_DISPLAY_NAMES[roleName] || fallback
}

/**
 * Gets a user-friendly display name for a user's role from their UserSummary
 * @param user The user summary object containing role information
 * @param fallback Optional fallback string if the role is unknown
 * @returns A formatted, user-friendly role name
 */
export function getUserRoleDisplay(user: UserDetailsResponse | null | undefined, fallback: string = 'Unknown'): string {
  if (!user || !user.roles)
    return fallback

  return formatRoleName(user.roles[0], fallback)
}
